import { FC } from 'react';
import { useTranslation } from '@packages/utils';
import { AutoComplete as AntAutoComplete, Spin } from 'antd';
import { AutoCompleteProps } from './AutoComplete.types';

export const AutoComplete: FC<AutoCompleteProps> = ({ ...props }) => {
  const { t } = useTranslation({
    keyPrefix: 'descriptions.generic-components.autocomplete',
  });

  const {
    placeholder = t('PLACEHOLDER'),
    loading,
    filterOption,
    ...restProps
  } = props;

  const defaultFilterOption = (inputValue: string, option: any) => {
    const label = option?.label;
    if (typeof label !== 'string') return false;
    return label.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1;
  };

  return (
    <AntAutoComplete
      placeholder={placeholder}
      filterOption={
        (filterOption !== undefined ? filterOption : defaultFilterOption) as any
      }
      notFoundContent={loading ? <Spin size="small" /> : undefined}
      {...restProps}
    />
  );
};

export default AutoComplete;
